// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"5be134e2","227":"7e224768","453":"cc9d0bf6","468":"0f4d2336","479":"7ab824cc","482":"9df1b591","748":"321026c3","794":"9b1bb060","811":"9ee8a1a1"}[chunkId] + ".chunk.js";
};